import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ palette: plt }: Theme) =>
  createStyles({
    buttons: {
      margin: '7px auto 20px',

      '& .MuiButtonBase-root': {
        margin: '0 8px',
      },
    },
    switchChecked: {
      '&.Mui-checked': {
        color: palette.green,

        '& + .MuiSwitch-track': {
          backgroundColor: palette.green,
        },
      },
    },
    switchLabel: {
      fontSize: 14,
    },
    switchRoot: {
      marginRight: 8,
    },

    autocomplete: {
      flex: 1,

      '& .MuiInputBase-input.Mui-disabled': {
        backgroundColor: palette.backgroundWhite,
      },
      '& .MuiInputBase-root': {
        display: 'inline',
        height: 'auto',
      },
      '& .MuiChip-outlined': { marginTop: 10 },
    },
    autocompleteError: {
      '& .MuiFormLabel-root, .MuiFormLabel-root.MuiFocused': {
        color: plt.error.light,
      },
      '& .MuiOutlinedInput-root, .MuiOutlinedInput-root:hover, .MuiOutlinedInput-root.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: plt.error.light,
        },
      },
    },

    errorMessage: {
      padding: 8,
    },

    chipError: {
      color: plt.error.light,
      borderColor: plt.error.light,
    },
    chipIcon: {
      color: plt.error.light,
      fontSize: 14,
      paddingLeft: 4,
    },
    chipDeleteIcon: {
      color: plt.error.light,

      '&:hover': {
        color: plt.error.dark,
      },
    },
    filterIP: {
      fontSize: 12,
    },
    forms: {
      '& .MuiFormControl-root': { margin: 6 },

      '& .MuiFormControlLabel-root': { marginLeft: 0 },
    },
    iconStyle: {
      color: palette.deepBlue,
      fontSize: 22,
    },
    footer: {
      display: 'block',
      justifyContent: 'flex-end',
    },
    buttonsBase: {
      borderTop: `1px solid ${palette.borderGray}`,
      justifyContent: 'right',
      paddingTop: 10,
    },
    buttonsAlign: {
      justifyContent: 'flex-end',
      display: 'flex',
      paddingBottom: 5,
    },

    titleGrid: {
      padding: 8,
      margin: 8,
      border: `1px solid ${palette.lightGray}`,
      borderRadius: 8,
    },
    titleGridError: {
      border: `1px solid ${palette.red}`,
    },

    partnersTable: {
      margin: '12px 0 10px 0',
      width: '100%',
    },
    likeCell: {
      width: 20,
      padding: 0,
      textAlign: 'center',

      '& svg': {
        fontSize: 14,
        fill: palette.primary.main,
      },
    },
    partnerSelected: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
        lineHeight: 0,
      },
    },
    partnerCell: {
      cursor: 'pointer',
      padding: '0px 0px 0px 16px',
      '& .MuiTableCell-root': {
        paddingLeft: 0,
      },
      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
    tableRow: {
      height: 20,
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    boldText: {
      fontWeight: 'bold',
      fontSize: 12,
    },
    text: {
      fontSize: 14,
    },
  });
